import React from 'react'

// TODO: Refactor these improts...
import { MenuItem, useSmallMenu } from 'components/Layout/components/Header/components/SmallMenu/components/MenuDropdown'
import { Wrapper } from 'components/Layout/components/Header/components/MenuItem/components/Styled'

interface Props {
  items: MenuItem[]
}

interface ItemProps {
  item?: MenuItem
  menuItems?: {items?: MenuItem[], parent: string}
}

export const ItemsRender: React.FC<Props> = ({ items }) => {
  return (
    <>
      {items?.map((item, i) => {
        const items = item?.items
        const parent = item?.parentId ?? 'root'
        const menuItems = {
          items: items,
          parent: parent
        }

        switch (item.render) {
          case 'text-icon':
            return (<TextIcon key={i} item={item} menuItems={menuItems} />)
          case 'image':
            return (<Image key={i} item={item} menuItems={menuItems} />)
          default:
            return (<Text key={i} item={item} menuItems={menuItems} />)
        }
      })}
    </>
  )
}

const Text: React.FC<ItemProps> = ({ item, menuItems }) => {
  const { setMenuItems } = useSmallMenu()
  return (
    <Wrapper
      onClick={item?.items?.length ? () => setMenuItems(menuItems) : undefined}
      isParent={item?.items?.length}
    >
      {item?.parentId
        ? <a href={item?.url}>{item?.label}</a>
        : <p>{item?.label}</p>}
    </Wrapper>
  )
}

const TextIcon: React.FC<ItemProps> = ({ item, menuItems }) => {
  const { setMenuItems } = useSmallMenu()

  return (
    <Wrapper
      className='has-icon'
      onClick={item?.items?.length ? () => setMenuItems(menuItems) : undefined}
      isParent={item?.items?.length}
    >
      <a href={item?.url}>
        <i className={`menu_icon ${item?.icon}`} />
        {item?.label}
      </a>
    </Wrapper>
  )
}

const Image: React.FC<ItemProps> = ({ item, menuItems }) => {
  const { setMenuItems } = useSmallMenu()

  return (
    <Wrapper
      onClick={item?.items?.length ? () => setMenuItems(menuItems) : undefined}
      isParent={item?.items?.length}
    >
      <a href={item?.url}>
        <img src={item?.image} alt={item?.label} />
      </a>
    </Wrapper>
  )
}
